module.exports = __webpack_public_path__ + "img/registrationChe.b43a0884.svg";